<desktop-isf-summary-card [header]="'LABELS.SHIPMENTS_DETAILS' | translate">
  <ng-container body>
    <div class="summary-shipment-details">
      <div class="summary-shipment-details-card" [ngClass]="{ 'is-editable': isEditMode }">
        <div class="summary-shipment-details-card-header">
          <div class="summary-shipment-details-card-header-text">
            <h3>{{ "LABELS.SHIPMENT_TYPE" | translate }}</h3>
          </div>

          <button
            type="button"
            class="btn btn-link d-print-none ml-2"
            *ngIf="isEditMode"
            (click)="editShipmentType.emit(isf?.shipment?.invoices)"
          >
            <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div class="summary-shipment-details-card-body">
          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ "LABELS.TYPE" | translate }}</div>

            <div class="shipment-details-value">
              <span [ngClass]="{ 'text-error': hasShipmentError }">
                {{ (isf?.type === enumIsfShipmentType.FORMAL ? "FORM_LABEL.FORMAL" : "FORM_LABEL.INFORMAL") | translate }}
              </span>
            </div>
          </div>

          <ng-container *ngIf="!!bond && isf?.type === enumIsfShipmentType.FORMAL">
            <div class="shipment-details-row">
              <div class="shipment-details-key">{{ "LABELS.BOND_TYPE" | translate }}</div>
              <div class="shipment-details-value" *ngIf="isContinuous">
                {{ "BOND_TYPE.CONTINUOUS" | translate }}
                <br />
                {{
                  (isf?.bondInfo?.suretyCode ? isf.bondInfo.suretyCode : "") +
                    " (" +
                    (company?.identifierQualifier | identifierQualifier | translate) +
                    " " +
                    (company?.identifier | identifier) +
                    ")"
                }}
              </div>
              <div class="shipment-details-value" *ngIf="!isContinuous">{{ "BOND_TYPE.SINGLE_TRANSACTION" | translate }}</div>
            </div>
            <ng-container *ngIf="!isContinuous">
              <div class="shipment-details-row">
                <div class="shipment-details-key">{{ "FORM_LABEL.SURETYCODE" | translate }}</div>
                <div class="shipment-details-value">
                  {{ bond.suretyCode }}
                  <div class="text-error" *ngIf="!bond.suretyCode">
                    {{ "LABELS.MISSING" | translate }}
                  </div>
                </div>
              </div>
              <div class="shipment-details-row">
                <div class="shipment-details-key">{{ "LABELS.REFERENCE_NUMBER" | translate }}</div>
                <div class="shipment-details-value">
                  {{ bond.referenceNumber }}
                  <div class="text-error" *ngIf="!bond.referenceNumber">
                    {{ "LABELS.MISSING" | translate }}
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="!!bondRequest && isf?.type === enumEntrySummaryType.FORMAL">
            <div [ngClass]="{ 'summary-shipment-details-card-bond': bondRequest.bondType === enumBondType.SINGLE_TRANSACTION }">
              <div class="shipment-details-row">
                <h3>{{ singleBondText | translate }}</h3>
              </div>

              <div class="shipment-details-row" *ngIf="isShowBR">
                <div class="shipment-details-key">{{ "LABELS.BOND_REQUEST_NUMBER" | translate }}</div>
                <div class="shipment-details-value">
                  <a href="" [routerLink]="['/bond-requests-management', bondRequest?.id]">{{ bondRequest?.referenceNumber }}</a>
                </div>
              </div>

              <ng-container *ngIf="bondRequest.bondType === enumBondType.SINGLE_TRANSACTION">
                <div class="shipment-details-row">
                  <div class="shipment-details-key">{{ "LABELS.BOND_TYPE" | translate }}</div>
                  <div class="shipment-details-value">
                    {{ "BOND_TYPE.SINGLE_TRANSACTION" | translate }}
                  </div>
                </div>

                <div class="shipment-details-row">
                  <div class="shipment-details-key">{{ "LABELS.ADDRESS" | translate }}</div>
                  <div class="shipment-details-value">
                    {{ arrivalPort ? arrivalPort.code + " " + arrivalPort.description : bondRequest.portCode }}
                    <div class="text-error" *ngIf="bondRequestPortCodeValidationText">
                      {{ bondRequestPortCodeValidationText | translate }}
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </ng-container>
          <ng-container *ngIf="!!estimatedIsfInfo && isf?.type === enumEntrySummaryType.INFORMAL">
            <div class="shipment-details-row">
              <div class="shipment-details-key">{{ "FORM_LABEL.ENTERED_VALUE" | translate }}</div>
              <div class="shipment-details-value">
                <div
                  *ngIf="estimatedIsfInfo.estimatedValue !== null && estimatedIsfInfo.estimatedValue !== undefined"
                  [ngClass]="{ 'text-error': hasEstimationInvalid }"
                >
                  {{ estimatedIsfInfo.estimatedValue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}

                  <span class="shipment-details-value-tooltip" *ngIf="hasEstimationInvalid && !!estimatedIsfInfo?.estimatedValue">
                    <app-hint-tooltip-icon
                      [hint]="getMaxText | translate : { actual: estimatedIsfInfo?.estimatedValue }"
                    ></app-hint-tooltip-icon>
                  </span>
                </div>

                <div class="text-error" *ngIf="!!hasEstimationValidationText('estimatedValue')">
                  {{ "LABELS.MISSING" | translate }}
                </div>
              </div>
            </div>
            <div class="shipment-details-row">
              <div class="shipment-details-key">{{ "LABELS.QUANTITY" | translate }}</div>
              <div class="shipment-details-value">
                {{ estimatedIsfInfo.quantity }} {{ estimatedIsfInfo.quantityUnit }}
                <div class="text-error" *ngIf="!!hasEstimationValidationText('quantity') || !!hasEstimationValidationText('quantityUnit')">
                  {{ "LABELS.MISSING" | translate }}
                </div>
              </div>
            </div>
            <div class="shipment-details-row">
              <div class="shipment-details-key">{{ "LABELS.WEIGHT" | translate }}</div>
              <div class="shipment-details-value">
                {{ estimatedIsfInfo.weight }}
                {{
                  estimatedIsfInfo.weightUnit === enumWeightUnit.KG
                    ? WEIGHT_UNIT_KG
                    : estimatedIsfInfo.weightUnit === enumWeightUnit.LB
                    ? WEIGHT_UNIT_LB
                    : ""
                }}
                <div class="text-error" *ngIf="!!hasEstimationValidationText('weight') || !!hasEstimationValidationText('weightUnit')">
                  {{ "LABELS.MISSING" | translate }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="summary-shipment-details-card" [ngClass]="{ 'is-editable': isEditMode }">
        <div class="summary-shipment-details-card-header">
          <div class="summary-shipment-details-card-header-text">
            <h3>{{ "LABELS.BILL_OF_LADING_DETAILS" | translate }}</h3>
          </div>

          <button type="button" class="btn btn-link d-print-none ml-2" *ngIf="isEditMode" (click)="editBL.emit()">
            <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                fill="currentColor"
              />
            </svg>
          </button>
        </div>

        <div class="summary-shipment-details-card-body">
          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ "LABELS.BL_TYPE" | translate }}</div>

            <div class="shipment-details-value">
              <span *ngIf="hasAnyBill">{{ (isMasterBill ? "FORM_LABEL.MASTER" : "FORM_LABEL.HOUSE") | translate }}</span>
              <span class="text-error" *ngIf="!hasAnyBill">{{ "LABELS.MISSING" | translate }}</span>
            </div>
          </div>

          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ "LABELS.CARRIER" | translate }}</div>

            <div class="shipment-details-value">
              <span *ngIf="hasAnyBillNumber">{{ carrierNumber }}</span>
              <span class="text-error" *ngIf="!hasAnyBillNumber">{{ "LABELS.MISSING" | translate }}</span>
            </div>
          </div>

          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ "LABELS.BL_NUMBER" | translate }}</div>

            <div class="shipment-details-value">
              <span *ngIf="hasAnyBillNumber">{{ billNumber }}</span>
              <span class="text-error" *ngIf="!hasAnyBillNumber">{{ "LABELS.MISSING" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</desktop-isf-summary-card>
